<template>
    <div class="cup-page">
        <page-hero :title="cupLeagueTitle" eyebrow="Cup">
            <template v-slot:aside>
                <v-icon size="64" class="cup-page__trophy">mdi-trophy-outline</v-icon>
            </template>
        </page-hero>
        <div class="cl-page">
            <v-tabs v-model="tab" class="cl-tabs mb-6" background-color="transparent" show-arrows>
                <v-tabs-slider class="custom-teal" />
                <v-tab v-for="(item, index) in items" :key="index">{{ item.name }}</v-tab>
            </v-tabs>
            <!-- the bracket made in the CMS -->
            <template v-if="tab === 0">
                <div v-if="errorMessage" class="cup-page__error">{{ errorMessage }}</div>
                <bracket-board v-else-if="bracketLoaded" :bracket="bracket" @match="openMatch" />
            </template>
            <schedule-league v-else-if="tab === 1" :matches="matches" />
            <league-stats v-else-if="tab === 2" :type="'cup'" :league="cupLeague" :season="seasonId" />
        </div>
    </div>
</template>

<script>
    import routeTab from '@/mixins/routeTab'
    import BracketBoard from '@/components/BracketBoard'
    import bracketService from '@/services/bracket'
    import leagueService from '@/services/league'
    import matchService from '@/services/match'
    import ScheduleLeague from '@/components/ScheduleMatchCenter'
    import LeagueStats from '@/components/LeagueStats'
    import PageHero from '@/components/PageHero'

    export default {
        components: { BracketBoard, ScheduleLeague, LeagueStats, PageHero },
        mixins: [routeTab],
        data() {
            return {
                loading: false,
                errorMessage: '',
                cupLeagueTitle: 'Cup League',
                cupLeague: null,
                matches: [],
                bracket: null,
                bracketLoaded: false,
                tab: null,
                seasonId: null,
                items: [
                    {
                        name: 'Standings'
                    },
                    {
                        name: 'Match Center'
                    },
                    {
                        name: 'Statistics'
                    }
                ]
            }
        },
        watch: {
            '$route.params.id': {
                handler() {
                    this.loadCupLeagueTree()
                }
            }
        },
        created() {
            this.loadCupLeagueTree()
            this.seasonId = this.$store.getters.getConfig?.activeSeasonId || null
        },
        methods: {
            openMatch(matchId) {
                this.$router.push(`/Match/${matchId}`)
            },
            async loadCupLeagueTree() {
                this.loading = true
                this.errorMessage = ''
                this.cupLeagueTitle = 'Cup League'
                this.matches = []
                this.bracket = null
                this.bracketLoaded = false

                try {
                    const cupLeagueId = Number(this.$route.params.id)
                    const seasonId = this.$store.getters.getConfig?.activeSeasonId

                    if (!seasonId) {
                        this.errorMessage = 'Δεν βρέθηκε ενεργή σεζόν στη ρύθμιση του συστήματος.'
                        return
                    }

                    if (!cupLeagueId) {
                        this.errorMessage = 'Μη έγκυρο Cup League id.'
                        return
                    }

                    bracketService.getBracket({ seasonId, cup: true, cupLeagueId }).then(resp => {
                        if (Number(this.$route.params.id) === cupLeagueId) {
                            this.bracket = resp.data || null
                        }
                    }).catch(() => {}).finally(() => {
                        if (Number(this.$route.params.id) === cupLeagueId) {
                            this.bracketLoaded = true
                        }
                    })

                    const cupLeagueResp = await leagueService.getCupLeague(cupLeagueId)
                    this.cupLeague = cupLeagueResp?.data || {}
                    this.cupLeagueTitle = this.cupLeague.title || this.cupLeague.name || this.cupLeagueTitle

                    const filters = { cup: `{isCup: true, season: ${seasonId}, cupLeague: ${cupLeagueId}}` }
                    const matchesResp = await matchService.getMatches(1, 1000, filters)
                    const seasonCupMatches = matchesResp?.data?.content || []

                    const currentCupLeagueMatches = seasonCupMatches.filter(match => {
                        const matchCupLeagueId = Number(match?.cupLeague?.id || match?.cupLeagueId || match?.cup_league_id || 0)

                        // If backend already filtered and relation is not populated, keep the match.
                        if (!matchCupLeagueId) return true
                        return matchCupLeagueId === cupLeagueId
                    })

                    this.matches = currentCupLeagueMatches
                } catch (error) {
                    this.errorMessage = 'Αποτυχία φόρτωσης αγώνων Cup League.'
                } finally {
                    this.loading = false
                }
            }
        }
    }
</script>

<style scoped>
    .cup-page__trophy {
        color: #03e5b7 !important;
        opacity: 0.85;
    }

    .cup-page__error {
        padding: 24px 16px;
        border-radius: 12px;
        background: #232323;
        color: rgba(255, 255, 255, 0.75);
        font-weight: 600;
        text-align: center;
    }
</style>
